import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import arrow from "../../assets/images/icons/arrow_title.svg";
import { GeneralButton, Modal } from "../../components";
import { useGetPersonalInfo } from "../../hooks";
import CompleteProfile from "./CompleteProfile";

interface IsProfileCompletedProps {
  children: React.ReactNode;
  onAllowedClick?: () => void;
  title?: string;
}

function IsProfileCompleted({
  children,
  onAllowedClick,
  title = "complete_your_profile_to_start_receiving_appointments",
}: IsProfileCompletedProps) {
  const { t } = useTranslation();
  const [isAllowedToOpen, setIsAllowedToOpen] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const { isAllowed, isLoading } = useGetPersonalInfo();

  const handleClick = () => {
    if (isAllowed) {
      onAllowedClick?.();
    } else {
      setIsAllowedToOpen(true);
    }
  };

  const childWithClickHandler = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      if (typeof child.type === "function") {
        return React.cloneElement(child as React.ReactElement<any>, {
          onClick: handleClick,
          isLoading: isLoading || child.props.isLoading,
        });
      }
      return React.cloneElement(child as React.ReactElement<any>, {
        onClick: handleClick,
      });
    }
    return child;
  });
  return (
    <>
      {childWithClickHandler}
      {isAllowedToOpen && (
        <Modal
          headerCustomStyle="!mb-0"
          customStyle="!max-w-[30rem] lg:!w-[30rem]"
          onClose={() => setIsAllowedToOpen(false)}
          isOpen={isAllowedToOpen}
          header={t(title)}
        >
          <div className="flex flex-col gap-8">
            <GeneralButton
              title={t("complete")}
              color="blue"
              icon={arrow}
              className="flex-row-reverse"
              onClick={() => {
                setIsOpen(true);
                setIsAllowedToOpen(false);
              }}
            />
          </div>
        </Modal>
      )}

      {isOpen && (
        <CompleteProfile isOpen={isOpen} onClose={() => setIsOpen(false)} />
      )}
    </>
  );
}

export default IsProfileCompleted;
